import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import { useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";
import DrawerComponent from './Drawer';
import { Outlet } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import { useTheme } from '@mui/material/styles';
// redux
import { useSelector, useDispatch } from 'react-redux';

import { isRepManager } from '@util/helper';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import ClassOutlinedIcon from '@mui/icons-material/ClassOutlined';
import WorkHistoryOutlinedIcon from '@mui/icons-material/WorkHistoryOutlined';
import UpcomingOutlinedIcon from '@mui/icons-material/UpcomingOutlined';
import EventRepeatOutlinedIcon from '@mui/icons-material/EventRepeatOutlined';
import CastForEducationOutlinedIcon from '@mui/icons-material/CastForEducationOutlined';
import CoPresentOutlinedIcon from '@mui/icons-material/CoPresentOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import HailOutlinedIcon from '@mui/icons-material/HailOutlined';
import logo from '@images/logo-tns.png'
import Avatar from '@mui/material/Avatar';
const useStyles = makeStyles((theme) => ({
  navlinks: {
    marginLeft: useTheme().spacing(5),
    display: "flex",
  },
  logo: {
    flex: 1,
    cursor: "pointer",
    color:'#fff',
    textDecoration: 'none',
  },
  link: {
    textDecoration: "none",
    color: "white",
    fontSize: "20px",
    marginLeft: useTheme().spacing(5),
    "&:hover": {
      color: "yellow",
      // borderBottom: "1px solid white",
    },
  },
  home: {
    textDecoration: "none",
    color: "white",
    fontSize: "20px",
    // marginLeft: theme.spacing(5),
    // "&:hover": {
    //   color: "yellow",
    // },
  },
}));

const drawerWidth = 240;

export default function GdnDrawer() {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  
  // redux
  const codeGroups = useSelector(state => state.codeGroupReducer)
  const codes = useSelector(state => state.codeReducer)
  const schools = useSelector(state => state.schoolReducer)
  const account = useSelector(state => state.accountReducer)
  const schola = useSelector(state => state.scholaReducer)

  const [activeMenu, set_activeMenu] = React.useState({})
  const [active_idx, set_activeIdx] = React.useState(0)

  const defIcon = <LabelOutlinedIcon size='small' sx={{color:'#214499'}}/>
  const sideMenu = [
    // {text:'Test',     to:'/scm/test'},
    {text:'일정',   to:'/gdn/schedule', visible: true, icon:<CalendarMonthOutlinedIcon size='small' sx={{color:'#214499'}}/> },
    {text:'수강신청',     to:'/gdn/lecture', visible: true, icon:<CastForEducationOutlinedIcon size='small' sx={{color:'#214499'}}/>},
    {text:'공지사항',     to:'/gdn/lecture', visible: true, },
    {text:'받은 메시지',     to:'/gdn/message', visible: true},
    // {text:'설문조사',     to:'/scm/attdnc'},
  ]
 
  return (
    <Box sx={{ display: 'flex',}}>
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1,}}>
        <Toolbar sx={{ backgroundColor:'#214499' }}>
          <Link to='/welcome'>
            <img src={logo} alt='logo' style={{width:55, marginRight:10,}} />
          </Link>
          
          <Typography variant="h6" noWrap component="div" className={classes.logo} component={Link} to='/welcome'>
            스쿨매니저
          </Typography>
          <Typography variant="h5" noWrap component="div" className={classes.logo} style={{textAlign:'center'}}>
            {schola.name}
          </Typography>
          {isMobile ? (
            <DrawerComponent />
          ) : (
            <div style={{flex:1, display:'flex', justifyContent:'flex-end'}}>
              <div className={classes.logo}></div>
              <div className={classes.navlinks}>
                <Link to="/profile" className={classes.link}>
                  My
                </Link>
                <Link to="/logout" className={classes.link}>
                  로그아웃
                </Link>
              </div>
            </div>
          )}
        </Toolbar>
        
      </AppBar>
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
        }}
      >
        <Toolbar />
        <Box sx={{ overflow: 'auto' }}>
          <List>
            {sideMenu.map((menu, index) => (
              menu.visible ?
              <ListItem key={menu.text} disablePadding component={Link} to={menu.to} onClick={()=> {set_activeIdx(index)}}>
                <ListItemButton selected={index === active_idx}>
                  <ListItemIcon>
                    {menu.icon ? menu.icon: defIcon}
                  </ListItemIcon>
                  <ListItemText sx={{color:'#214499'}} primary={menu.text} />
                </ListItemButton>
              </ListItem>
              : null
            ))}
          </List>
          {/*
          <Divider />
            <List>
            {['All mail', 'Trash', 'Spam'].map((text, index) => (
              <ListItem key={text} disablePadding>
                <ListItemButton>
                  <ListItemIcon>
                    {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                  </ListItemIcon>
                  <ListItemText primary={text} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
            */}
          
        </Box>
      </Drawer>
      <Box component='main' sx={{ flexGrow: 1, p: 3 }}>
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
}
